import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import { DefaultButton } from '~/components/atomic';

export const BannerSwiper = styled(Swiper)`
  position: relative;

  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    position: absolute;
    bottom: 14px;
    left: 16px;
    width: auto;

    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      margin: 0 3px;
      border: 1px solid ${({ theme }) => theme.stroke.stroke_1};
      opacity: 1;
      background: transparent;
    }

    .swiper-pagination-bullet-active {
      width: 8px;
      height: 8px;
      border: 1px solid transparent;
      background: #ffffff;
    }
  }
`;

export const BannerSlide = styled(SwiperSlide)`
  position: relative;
  min-height: 367px;
  max-height: 448px;
  overflow: hidden;
  ${(props) => props.theme.mixins.aspectRatio.ratio5_6};

  img {
    width: 100%;
    height: 100%;
    border-radius: 24px;
    object-fit: cover;
  }
`;

export const BannerBackground = styled.div`
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 75%
  );
`;

export const BannerSlideDetail = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    z-index: 2;
    bottom: 12px;
    left: 16px;
    flex-direction: column;
    width: 80%;
    gap: 16px;

    .name {
      width: 100%;
      color: ${theme.content.content_light_1};
      ${theme.fontStyle.title.section24_bold};
      ${theme.mixins.text.ellipsis_1};
      font-family: Poppins;
      text-shadow: 0px 0px 24px rgba(0, 0, 0, 0.25);
    }

    .detail {
      width: 100%;
      color: ${theme.content.content_light_2};
      ${theme.fontStyle.text.body16_medium};
      ${theme.mixins.text.ellipsis_2};
      font-family: Poppins;
      text-shadow: 0px 0px 24px rgba(0, 0, 0, 0.25);
    }
  `}
`;

export const StyledChatButton = styled(DefaultButton)`
  ${({ theme }) => css`
    width: 92px;
    padding: 0 12px 0 8px;
    color: ${theme.content.content_dark_1};
    font-family: Poppins;
    ${theme.fontStyle.text.body16_medium};
  `}
`;
